
    import './styles.scoped.css';
    export default {
  "root": "_root_1srpo_3",
  "checkbox-control": "_checkbox-control_1srpo_14",
  "input": "_input_1srpo_22"
};
  